import {
    LEAD_APPROVAL_GET_LEADS,
    LEAD_APPROVAL_GET_LEADS_SUCCESS,
    LEAD_APPROVAL_GET_LEADS_FAILURE,
} from '../constants/lead_approval_get_leads.constants';

const initialState = {
    loading: false,
    error: null,
    leads: [],
};

export const Lead_approval = (state = initialState, action) => {
    switch (action.type) {
    case LEAD_APPROVAL_GET_LEADS:
        return {
            ...state,
            loading: true,
        };
    case LEAD_APPROVAL_GET_LEADS_SUCCESS:
        return {
            ...state,
            loading: false,
            leads: action.leads,
        };
    case LEAD_APPROVAL_GET_LEADS_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_approval/redux/reducers/lead_approval_get_leads.reducer.js